import { render } from "./InstallPrompt.vue?vue&type=template&id=cd28b35e&scoped=true"
import script from "./InstallPrompt.vue?vue&type=script&lang=js"
export * from "./InstallPrompt.vue?vue&type=script&lang=js"

import "./InstallPrompt.vue?vue&type=style&index=0&id=cd28b35e&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Kos\\Downloads\\filemgr.mREaF3.2026-05-15_16_14_46\\vxadoor.pro\\hubuntu\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cd28b35e"]])

export default __exports__